import Util from "@/helper/Utility.js";

export function SerialModel () {
    this.campaignImgUrl = '';
    this.campaignName = '';
    this.currentTimestamp = '';
    this.expireIn = '';
    this.privilegeMessage = '';
    this.privilegeMessageFormat = '';
    this.redeemTimestamp = '';
    this.serial = '';
    this.serialType = '';
    this.showTimer = false;
    this.campaign = {};

    /**
     * @param {CampaignModel} campaign /core/Campaign/model/CampaignModel.js
     */
    this.setModelFromDataModel = function(campaign) {
        this.campaignImgUrl = campaign.fullImageUrl || '';
        this.campaignName = campaign.name || '';
        this.expireIn = campaign.expireIn || 0;
        this.privilegeMessage = campaign.privilegeMessage || '';
        this.privilegeMessageFormat = campaign.privilegeMessageFormat | '';
        this.redeemTimestamp = campaign.redeemDate || '';
        this.serial = campaign.serial || '';
        this.serialType = campaign.barcode || '';
        if (Util.isNumber(campaign.minutesValidAfterUsed) && campaign.minutesValidAfterUsed > 0) {
            this.showTimer = true;
        }
        this.campaign = campaign;
    };
}
